export default "__VITE_ASSET__612c7d11__"